import { riskMeta } from "@/lib/skills/constants";
import type { RiskLevel } from "@/lib/skills/types";
import { cn } from "@/lib/utils";

export function RiskBadge({ level, className }: { level: RiskLevel; className?: string }) {
  const meta = riskMeta(level);
  const Icon = meta.icon;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold",
        meta.className,
        className,
      )}
    >
      <Icon className="size-3.5" />
      {meta.label}
    </span>
  );
}
